"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _system = require("@/api/system");
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    roleFilter: function roleFilter(val) {
      if (val === 'superAdmin') {
        val = '超管';
      } else if (val === 'admin') {
        val = '高级运营';
      } else if (val === 'operation') {
        val = '运营';
      } else if (val === 'customer') {
        val = '客服';
      } else if (val === 'broker') {
        val = '公会长';
      } else if (val === 'finance') {
        val = '财务';
      }
      return val;
    },
    typeFilter: function typeFilter(val) {
      if (val === -1) {
        val = '未知';
      } else if (val === 0) {
        val = '登录';
      } else if (val === 1) {
        val = '删除';
      } else if (val === 2) {
        val = '添加';
      } else if (val === 3) {
        val = '编辑';
      } else if (val === 4) {
        val = '更新';
      } else if (val === 5) {
        val = '审核';
      } else if (val === 6) {
        val = '处理';
      } else if (val === 7) {
        val = '提现';
      }
      return val;
    }
  },
  data: function data() {
    return {
      typeList: [{
        label: '未知',
        value: -1
      }, {
        label: '登录',
        value: 0
      }, {
        label: '删除',
        value: 1
      }, {
        label: '添加',
        value: 2
      }, {
        label: '编辑',
        value: 3
      }, {
        label: '更新',
        value: 4
      }, {
        label: '审核',
        value: 5
      }, {
        label: '处理',
        value: 6
      }, {
        label: '提现',
        value: 7
      }],
      listLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 10,
        type: '',
        userName: '',
        content: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$logsList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _system.logsList)(this.listQuery);
            case 1:
              _yield$logsList = _context.v;
              code = _yield$logsList.code;
              data = _yield$logsList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listQuery.page = 1;
              this.getList();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }()
  }
};